import { queryOptions } from '@tanstack/react-query';
import { DeviceDetailsModel } from '~/shared/models/system/DeviceDetailsModel';
import { getDeviceDetails } from '~/services/api/fetchers/deviceDetails.api';

export const getDeviceDetailsQuery = (resourceName: string) =>
  queryOptions({
    queryKey: ['deviceDetails', resourceName],
    queryFn: async () => {
      const deviceDetailsResponse = await getDeviceDetails(resourceName);
      return new DeviceDetailsModel(deviceDetailsResponse);
    },
  });
